import React from 'react';
import Trophy from 'lucide-react/dist/esm/icons/trophy.js';
import Star from 'lucide-react/dist/esm/icons/star.js';
import { useContent } from '../../../contexts/ContentContext';
import { useTranslations } from '../../../contexts/TranslationContext';
import { useLanguage } from '../../../contexts/LanguageContext';
import { formatCurrencyValue } from '../../../utils/formatCurrency';
import { useWinnersPage } from './WinnersPageContext';

export default function WinnersSpotlightSection() {
  const { c } = useContent();
  const { t } = useTranslations();
  const { language } = useLanguage();
  const { filteredWinners } = useWinnersPage();

  // Show the first winner as a spotlight if there are winners
  if (!filteredWinners || filteredWinners.length === 0) {
    return null;
  }

  const spotlight = filteredWinners[0];

  return (
    <div className="bg-gradient-to-br from-yellow-50 to-orange-50 dark:from-yellow-900/20 dark:to-orange-900/20 rounded-xl p-8 shadow-xl border-2 border-yellow-200 dark:border-yellow-700 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <Star className="w-6 h-6 text-yellow-600 dark:text-yellow-400" fill="currentColor" />
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          {c('WinnersSpotlightTitle', 'Featured Winner')}
        </h2>
      </div>

      <div className="flex flex-col md:flex-row items-center gap-8">
        <div className="relative">
          <div className={`absolute inset-0 bg-gradient-to-br ${spotlight.color} rounded-full blur-2xl opacity-60`}></div>
          <div className={`relative w-32 h-32 bg-gradient-to-br ${spotlight.color} rounded-full flex items-center justify-center text-white font-bold text-5xl shadow-2xl`}>
            {spotlight.avatar}
          </div>
        </div>

        <div className="flex-1 text-center md:text-left">
          <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            {spotlight.name}
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {spotlight.draw} • {spotlight.date}
          </p>
          <div className="inline-flex items-center gap-3 bg-gradient-to-br from-green-100 to-emerald-100 dark:from-green-900/40 dark:to-emerald-900/40 rounded-lg px-8 py-4 border border-green-200 dark:border-green-700">
            <Trophy className="w-6 h-6 text-green-600 dark:text-green-400" />
            <div>
              <p className="text-sm text-green-700 dark:text-green-400 font-medium uppercase mb-1">
                {spotlight.gameType === 'prizeDraw' ? t('winners.winnerPrizeLabel.prizeWon', 'Prize Won') : t('WinnersSpotlightWinnings', 'Winnings')}
              </p>
              {spotlight.prize ? (
                <p className="text-3xl font-bold text-green-600 dark:text-green-400">
                  {spotlight.prize}
                </p>
              ) : (
                <p className="text-3xl font-bold text-green-600 dark:text-green-400">
                  {formatCurrencyValue(spotlight.amount, { language })}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
